@let toasts = toasterFeature.selectors.toasts.asSignal();

@if (toasts.length) {
  <div
    class="atn-platform-toaster"
    aria-live="polite"
    aria-atomic="false"
  >
    @for (toast of toasts; track toast.id) {
      <div
        class="atn-platform-toaster__toast"
        [ngClass]="{
          'atn-platform-toaster__toast--error': toast.style === 'error',
          'atn-platform-toaster__toast--info': toast.style === 'info',
          'atn-platform-toaster__toast--success': toast.style === 'success',
          'atn-platform-toaster__toast--warning': toast.style === 'warning',
        }"
      >
        <div class="atn-platform-toaster__header">
          <div class="atn-platform-toaster__title">
            <atn-ds-notice-icon [style]="toast.style" />
            <span>{{ toast.name ?? 'Notification' }}</span>
          </div>

          @if (toast.dismissible) {
            <button
              type="button"
              class="atn-platform-toaster__dismiss"
              (click)="dismiss(toast.id)"
              aria-label="Dismiss notification"
            >
              <i class="atn-icon atn-close atn-dark"></i>
            </button>
          }
        </div>

        @if (toast.description) {
          <div class="atn-platform-toaster__description">
            {{ toast.description }}
          </div>
        }

        @if (toast.actions.length) {
          <div class="atn-platform-toaster__actions">
            @for (action of toast.actions; track action.id) {
              <button
                type="button"
                class="atn-platform-toaster__action"
                [ngClass]="{
                  'atn-platform-toaster__action--button':
                    action.kind === 'button',
                  'atn-platform-toaster__action--link': action.kind === 'link',
                }"
                (click)="clickAction(toast.id, action.id)"
              >
                {{ action.name ?? action.id }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
}
